import { IGiftCardDetail } from 'features/cashier/services/types/giftCard';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
type Props = {
  data: IGiftCardDetail | null;
  balance?: number;
  resultGiftCard?: {
    available: number;
    amount: number;
    used: number;
    expireDate: string;
    expireDateV2: string;
  } | null;
};

const GiftCardInfoBox = ({ data, resultGiftCard, balance = 0 }: Props) => {
  return (
    <Container>
      <InfoBox label={'Balance'} value={formatCurrency(balance > 0 ? balance : 0)} />
      <InfoBox label={'Available'} value={formatCurrency(resultGiftCard?.available)} />
      <InfoBox label={'Used'} value={formatCurrency(resultGiftCard?.used)} />
      <InfoBox label={'Last Used Date'} value={data?.updatedDate ? moment(data?.updatedDate).format('MM-DD-YYYY') : '__/__/____'} />
      <InfoBox label={'Expiration'} value={resultGiftCard?.expireDateV2 || '__/__/____'} />
    </Container>
  );
};

export default GiftCardInfoBox;

const Container = styled.div`
display: flex;
padding: 0px 16px;
align-items: flex-start;
background: #E5E6EB;
`;

type InfoBoxProps = {
  label: string;
  value: string;
};
const InfoBox = ({ label, value }: InfoBoxProps) => {
  return (
    <InfoBoxContainer>
      <p className='label'>{label}</p>
      <p className="value">{value}</p>
    </InfoBoxContainer>
  );
};

const InfoBoxContainer = styled.div`
display: flex;
padding: 24px 8px;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 12px;
flex: 1 0 0;
align-self: stretch;
border-right: 1px solid #CCD4DC;
p.label {
  color: #2D6772;
  text-align: center;
  align-self: stretch;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
p.value {
  color: #1D2129;
  text-align: center;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
`;
